import React, { useEffect, useState } from "react";
import { Form, Input, Button, message } from "antd";
import SummaryApi from "../../../common/index";
import axios from "axios";

const AdminProfile = () => {
  const [admin, setAdmin] = useState({});

  const fetchProfile = async () => {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      message.error("No admin token found. Please login.");
      return;
    }

    try {
      const res = await axios.get(SummaryApi.getAdminProfile.url, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      if (res.data.success) {
        setAdmin(res.data.admin);
      } else {
        message.error(res.data.message || "Failed to fetch profile");
      }
    } catch (err) {
      console.error("Fetch profile error:", err.response || err);
      message.error("Error fetching profile");
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const onFinish = async (values) => {
    const token = localStorage.getItem("adminToken");
    try {
      const res = await axios({
        method: SummaryApi.updateAdminProfile.method,
        url: SummaryApi.updateAdminProfile.url,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: values,
      });

      if (res.data.success) {
        message.success("Profile updated successfully");
        setAdmin(res.data.admin);
      } else {
        message.error(res.data.message || "Failed to update profile");
      }
    } catch (err) {
      console.error("Update profile error:", err);
      message.error("Failed to update profile");
    }
  };

  // Render
  return (
    <>
      {admin && (
        <Form
          layout="vertical"
          initialValues={{
            name: admin.name || "",
            email: admin.email || "",
          }}
          onFinish={onFinish}
          style={{ maxWidth: 500 }}
          key={admin.id || "form"}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Enter name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: "Enter email" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update Profile
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};

export default AdminProfile;
